'use strict';
import $ from 'jquery';

export default class Features {
  constructor() {

    // Slide to hovered feature
    $(document).on('click', '.js-feature', function(e) {
        e.preventDefault();
        $(".js-feature.-active").removeClass('-active');
        $(this).addClass('-active');

        var offset = $(this).position().top;
        var parent_height = $(this).parent().outerHeight();
        var pointer_offset = ((offset / parent_height) * 100) + 1.5;
        $('.js-features-pointer').css({'top' : pointer_offset + '%'});

        var image = $(this).find('.js-feature-image').clone().removeClass().addClass('features__image__img');
        $(".js-features-imageHolder").html(image);

    });

  }
}
